<script lang="ts">
	// components/navbar/menu/MenuDrawer.svelte

	// IMPORTS
	import { Languages, Newspaper, Cog } from 'lucide-svelte';
	import { SlideToggle } from '@skeletonlabs/skeleton';
	import FollowUsButtons from '$components/Navbar/menu/FollowUsButtons.svelte';
	import ShareButton from '$components/Navbar/menu/ShareButton.svelte';
	import { mutedStore, toggleMuted } from '$stores/mutedStore';
	import { autoScrollStore, toggleAutoScroll } from '$stores/autoScrollStore';

	// TYPES
	type FollowLink = {
		platform: string;
		url: string;
	};

	type Settings = {
		title: string;
		mute?: string;
		reducedMotion?: string;
		autoscroll?: string;
	};

	type OtherVersion = {
		heading: string;
		versions: { language: string; link: string }[];
	};

	type Follow = {
		heading: string;
		links: FollowLink[];
	};

	type uiText = {
		otherVersions: OtherVersion;
		follow: Follow;
		settings: Settings;
	};

	// PROPS
	export let text: uiText;

	// VARIABLES
	let canShare: boolean = false;
	let muted: boolean = false;
	let autoscroll: boolean = false;

	// LOGIC
	if (typeof navigator.canShare === 'function') {
		canShare = true;
	}

	// REACTIVITY
	$: {
		muted = $mutedStore.muted;
		autoscroll = $autoScrollStore.enabled;
	}
</script>

<div class="drawer-container">
	<div class="links">
		<!-- {#if text.otherVersions}
			<div class="link-section">
				<div class="link-title">
					<Languages size="{18}" /><span>{text.otherVersions.heading}</span>
				</div>
				<ul class="links">
					{#each text.otherVersions.versions as version}
						<a href="{version.link}" target="_blank"
							><li>{version.language}</li></a
						>
					{/each}
				</ul>
			</div>
		{/if} -->
		<div class="link-section">
			<div class="link-title">
				<Cog size="{18}" /><span>{text.settings.title}</span>
			</div>
			<ul class="settings">
				{#if text.settings.mute}
					<li class="setting">
						<div class="setting_label">{text.settings.mute}</div>
						<div class="setting_toggle">
							<SlideToggle
								checked="{muted}"
								name="slider-label"
								size="sm"
								on:click="{toggleMuted}"
								active="bg-primary-500 dark:bg-primary-500"
								background="bg-surface-300 dark:bg-surface-300"
							/>
						</div>
					</li>
				{/if}
				{#if text.settings.autoscroll}
					<li class="setting">
						<div class="setting_label">{text.settings.autoscroll}</div>
						<div class="setting_toggle">
							<SlideToggle
								checked="{autoscroll}"
								name="slider-label"
								size="sm"
								on:click="{toggleAutoScroll}"
								active="bg-primary-500 dark:bg-primary-500"
								background="bg-surface-300 dark:bg-surface-300"
							/>
						</div>
					</li>
				{/if}
			</ul>
		</div>
		<div class="link-section">
			<div class="link-title">
				<Newspaper size="{18}" /><span>{text.follow.heading}</span>
			</div>
			<FollowUsButtons />
		</div>
	</div>
	{#if canShare}
		<ShareButton />
	{/if}
</div>

<style lang="scss">
	@use '$styles/colors' as *;

	:global(.slide-toggle) {
		width: 100%;
	}

	:global(.slide-toggle-text) {
	}

	.drawer-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-top: 63px;
		height: 100%;
		color: var(--brand-secondary);
	}

	.link-section {
		margin: 0 16px 8px 16px;
		padding-top: 16px;
	}

	.link-title {
		border-bottom: 1px solid $rfe-gray-1;
		padding-bottom: 8px;
		font-weight: bold;
		text-transform: uppercase;
	}

	ul {
		padding-top: 8px;
	}

	ul li {
		padding: 8px 0 8px 8px;
	}

	ul.links li {
		border-radius: 7px;

		&:hover {
			background: $rfe-gray-1;
			color: var(--brand-primary);
		}
	}

	li.setting {
		display: flex;
		justify-content: space-between;
	}

	:global(.link-title svg.lucide) {
		stroke-opacity: 0.6;
		display: inline;
		margin-right: 8px;
	}
</style>
